import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'legend-type-selector',
  templateUrl: 'legend-type-selector.component.html',
  styleUrls: ['legend-type-selector.component.scss']
})
export class MapLegendTypeSelectorComponent implements OnInit {

  @Input() public categoriesList;
  @Output() public onCloseClick: EventEmitter<any> = new EventEmitter();
  @Output() public radioChange: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
   }
}
